import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useCart } from '../contexts/CartContext'

export function Navbar() {
  const { user, logout } = useAuth()
  const { itemCount } = useCart()
  const navigate = useNavigate()

  async function handleLogout() {
    await logout()
    navigate('/')
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🔧</span>
          <span className="brand-name">FerreMarket</span>
          <span className="brand-country">Guatemala</span>
        </Link>
        <div className="navbar-actions">
          {user ? (
            <>
              {user.role === 'super_admin' && (
                <Link to="/admin" className="navbar-link">Panel Admin</Link>
              )}
              {user.role === 'admin_ferreteria' && (
                <Link to="/mi-tienda" className="navbar-link">Mi Tienda</Link>
              )}
              {user.role === 'trabajador' && (
                <Link to="/trabajador" className="navbar-link">Mi Panel</Link>
              )}
              {itemCount > 0 && (
                <Link to="/checkout" className="cart-badge-btn" style={{ textDecoration: 'none' }}>
                  🛒
                  <span className="cart-count">{itemCount}</span>
                </Link>
              )}
              <span className="navbar-user">{user.fullName}</span>
              <button type="button" className="btn btn-outline btn-sm" onClick={handleLogout}>
                Salir
              </button>
            </>
          ) : (
            <>
              {itemCount > 0 && (
                <Link to="/checkout" className="cart-badge-btn" style={{ textDecoration: 'none' }}>
                  🛒
                  <span className="cart-count">{itemCount}</span>
                </Link>
              )}
              <Link to="/login" className="btn btn-primary btn-sm">Ingresar</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}
